export function getLastDayOfMonth(month: number, year: number): number {
  // Los meses en JavaScript/TypeScript van del 0 (enero) al 11 (diciembre)
  return new Date(year, month + 1, 0).getDate();
}
